
    import { defineComponent } from 'vue'
    import { iKpiSchedule } from './KpiScheduler'
    import { AxiosResponse } from 'axios'
    import Chip from 'primevue/chip'
    import kpiSchedulerDescriptor from './KpiSchedulerDescriptor.json'
    import FabButton from '@/components/UI/KnFabButton.vue'
    import Listbox from 'primevue/listbox'
    import Menu from 'primevue/menu'

    export default defineComponent({
        name: 'kpi-scheduler',
        components: { Chip, FabButton, Listbox, Menu },
        data() {
            return {
                kpiSchedulerDescriptor,
                schedulerList: [] as iKpiSchedule[],
                items: [] as { label: String; icon: string; command: Function }[],
                loading: false,
                touched: false
            }
        },

        async created() {
            await this.loadPage()
        },
        methods: {
            async loadAllSchedules() {
                this.loading = true
                await this.$http
                    .get(process.env.VUE_APP_RESTFUL_SERVICES_PATH + '1.0/kpi/listSchedulerKPI')
                    .then((response: AxiosResponse<any>) => {
                        this.schedulerList = response.data
                        this.schedulerList.sort((a: iKpiSchedule, b: iKpiSchedule) => (a.name.toUpperCase() > b.name.toUpperCase() ? 1 : -1))
                    })
                    .finally(() => (this.loading = false))
            },
            async loadPage() {
                this.loading = true
                await this.loadAllSchedules()
                this.touched = false
                this.loading = false
            },
            toggle(event: any, scheduler: iKpiSchedule) {
                this.createMenuItems(scheduler)
                const menu = this.$refs.menu as any
                menu.toggle(event)
            },
            createMenuItems(scheduler: iKpiSchedule) {
                this.items = []
                this.items.push({ label: this.$t('common.clone'), icon: 'pi pi-copy', command: () => this.cloneSchedulerConfirm(scheduler) })
                this.items.push({ label: this.$t('common.delete'), icon: 'far fa-trash-alt', command: () => this.deleteScheduleConfirm(scheduler.id as number) })
            },
            playIcon(jobStatus: string) {
                return jobStatus.toUpperCase() === 'SUSPENDED' ? 'fa fa-play' : 'fa fa-pause'
            },
            cloneSchedulerConfirm(scheduler: iKpiSchedule) {
                this.$confirm.require({
                    header: this.$t('common.toast.cloneConfirmTitle'),
                    accept: () => this.showForm(scheduler, true)
                })
            },
            showForm(event: any, clone: boolean) {
                clone = clone ? true : false

                const path = event.id ? `/kpi-scheduler/edit-kpi-schedule?id=${event.id}&clone=${clone}` : '/kpi-scheduler/new-kpi-schedule'
                if (!this.touched) {
                    this.$router.push(path)
                } else {
                    this.$confirm.require({
                        message: this.$t('common.toast.unsavedChangesMessage'),
                        header: this.$t('common.toast.unsavedChangesHeader'),
                        icon: 'pi pi-exclamation-triangle',
                        accept: () => {
                            this.touched = false
                            this.$router.push(path)
                        }
                    })
                }
            },
            startSchedule(schedule: iKpiSchedule) {
                if (schedule.jobStatus?.toUpperCase() === 'EXPIRED') {
                    return
                }
                const query = '?jobGroup=KPI_SCHEDULER_GROUP&triggerGroup=KPI_SCHEDULER_GROUP&jobName=' + schedule.id + '&triggerName=' + schedule.id
                const action = schedule.jobStatus?.toUpperCase() === 'SUSPENDED' ? 'resumeTrigger' : 'pauseTrigger'
                this.$http.post(process.env.VUE_APP_RESTFUL_SERVICES_PATH + 'scheduler/' + action + query).then((response: AxiosResponse<any>) => {
                    if (response.data.resp === 'ok') {
                        schedule.jobStatus = schedule.jobStatus === 'SUSPENDED' ? 'ACTIVE' : 'SUSPENDED'
                    }
                })
            },
            deleteScheduleConfirm(scheduleId: number) {
                this.$confirm.require({
                    message: this.$t('common.toast.deleteMessage'),
                    header: this.$t('common.toast.deleteTitle'),
                    icon: 'pi pi-exclamation-triangle',
                    accept: () => this.deleteSchedule(scheduleId)
                })
            },
            async deleteSchedule(scheduleId: number) {
                await this.$http.delete(process.env.VUE_APP_RESTFUL_SERVICES_PATH + `1.0/kpi/${scheduleId}/deleteKpiScheduler`).then(() => {
                    this.$store.commit('setInfo', {
                        title: this.$t('common.toast.deleteTitle'),
                        msg: this.$t('common.toast.deleteSuccess')
                    })
                    this.$router.push('/kpi-scheduler')
                    this.loadPage()
                })
            },
            getBordersClass(jobStatus: string) {
                switch (jobStatus) {
                    case 'SUSPENDED':
                        return 'kn-list-item-warning'
                    case 'ACTIVE':
                        return 'kn-list-item-success'
                    case 'EXPIRED':
                        return 'kn-list-item-error'
                }
            }
        }
    })
